import { Link } from "react-router-dom";
import { Heart, Trash2 } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { inr, buildLabel } from "../lib/api";

export default function Wishlist() {
  const { wishlist, toggleWishlist, addToCart } = useStore();
  return (
    <div className="container-hw py-12 lg:py-16">
      <p className="eyebrow">Saved for later</p>
      <h1 className="mt-3 text-4xl sm:text-5xl">Your wishlist</h1>
      {wishlist.length === 0 ? (
        <div data-testid="wishlist-empty" className="mt-12 rounded-md border border-dashed border-border p-12 text-center">
          <Heart className="mx-auto h-8 w-8 text-muted-foreground" />
          <p className="mt-4 font-display text-2xl">Nothing saved yet.</p>
          <p className="mt-2 text-muted-foreground">Tap the heart on any piece to keep it here while you measure the room.</p>
          <Link to="/shop" className="btn-sheesham mt-6">Browse pieces</Link>
        </div>
      ) : (
        <ul className="mt-10 divide-y divide-border border-y border-border">
          {wishlist.map((p) => (
            <li key={p.slug} data-testid={`wishlist-item-${p.slug}`} className="flex flex-wrap items-center gap-5 py-6">
              <Link to={`/product/${p.slug}`}><img src={p.image} alt={p.name} className="h-24 w-24 rounded object-cover" /></Link>
              <div className="min-w-[180px] flex-1">
                <Link to={`/product/${p.slug}`} className="font-display text-xl">{p.name}</Link>
                <p className="text-sm text-muted-foreground">{p.tagline}</p>
                <p className="mt-1 text-xs text-muted-foreground">{buildLabel(p.build_minutes)}</p>
              </div>
              <div className="text-right">
                <p className="font-semibold">{inr(p.price)}</p>
                <p className="text-sm text-muted-foreground line-through">{inr(p.mrp)}</p>
              </div>
              <div className="flex gap-2">
                <button data-testid={`wishlist-move-to-cart-${p.slug}`} onClick={() => { addToCart(p); toggleWishlist(p); }} className="btn-sheesham">Move to cart</button>
                <button data-testid={`wishlist-remove-${p.slug}`} onClick={() => toggleWishlist(p)} aria-label="Remove" className="grid h-11 w-11 place-items-center rounded-full border border-border hover:text-sheesham"><Trash2 className="h-4 w-4" /></button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
